module.exports = __webpack_public_path__ + "img/hc_pro_four_2.8a0f3bfb.jpg";